import { isEmpty, startCase } from "lodash";
import React, { useContext, useState } from "react";
import { Button, Table } from "react-bootstrap";
import DropDown from "./DropDown";
import helpers from "../../utils/helpers";
import AuthContext from "../../context/AuthContext";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import iconfromto from "../../assets/images/icon-fromto.png";
import obj from "../../utils/helpers";
// import BetTypeListInner from "./BetTypeListInner";

const BetTypeListing = ({ title, first, second, odds, oldOdds }) => {
  const [showMatch, setShowMatch] = useState(false);
  let { user } = useContext(AuthContext);
  const [selectData, setSelectData] = useState("");
  const [id, setId] = useState("");
  const [id2, setId2] = useState("");
  const navigate = useNavigate();

  const BetFairMulti = ({ data, index, indexNew, type }) => {
    index = 0;
    return data?.map((res, innerIndex) => {
      let upadtedOdds =
        odds?.find((oi) => {
          return oi?.mi == res?.marketId;
        }) || {};
      let upadtedOddsOld =
        oldOdds?.find((oi) => {
          return oi?.mi == res?.marketId;
        }) || {};
      return (
        <>
          <tr key={index + 1}>
            {index == innerIndex && (
              <>
                <td className="text-start" rowSpan={data?.length + 1}>
                  <p className="blue-text">{startCase(res.gameType)}</p>
                </td>
                <td className="text-start" rowSpan={data?.length + 1}>
                  {helpers.matchDateTimeNew(res?.eventDateTime, user.timeZone)}
                </td>
              </>
            )}
            <td className="bg-yellow border-0 risk-match-name">
              <a>
                {title != "Book Maker" && (
                  <>
                    {res?.marketId == id ? (
                      <Button
                        onClick={() => {
                          setShowMatch(false);
                          setSelectData("");
                          setId("");
                          setId2("");
                        }}
                        className={"angle-up"}
                      >
                        <i className="fas fa-angle-up"></i>
                      </Button>
                    ) : (
                      <Button
                        onClick={() => {
                          setShowMatch(true);
                          setId(res?.marketId);
                          setSelectData(res);
                          setId2(indexNew);
                        }}
                        className={"angle-up down-up"}
                      >
                        <i className="fas fa-angle-up"></i>
                      </Button>
                    )}
                  </>
                )}
                <strong style={{ marginLeft: "10px" }}>
                  <Link
                    onClick={() =>
                      window
                        .open(
                          `/risk-betfair/${res?.eventId}/${res?.marketId}`,
                          "_blank",
                          "width=1100, height=700"
                        )
                        .focus()
                    }
                  >
                    {res.eventName}
                  </Link>
                </strong>{" "}
                <img className="fromto" src={iconfromto} />
                <span className="ms-3">
                  {res?.market ? res?.market : "Bookmaker"}{" "}
                </span>
              </a>
            </td>

            {res?.runners?.length > 0 &&
              res?.runners?.map((item, index) => {
                let position = res?.position?.find(
                  (res) =>
                    res?.selectionId == (item?.selectionID || item?.SelectionId)
                )?.position;
                return (
                  <>
                    <td
                      style={{ justifyContent: "flex-end" }}
                      className="border-0 bg-yellow text-end"
                    >
                      <p
                        className={
                          Math.sign(position) == -1
                            ? "text-danger"
                            : "text-success text-danger-new"
                        }
                      >
                        {Math.sign(position) == -1
                          ? `(${obj.currencyFormat(Math.abs(position))})`
                          : obj.currencyFormat(Math.abs(position))}
                      </p>
                    </td>
                  </>
                );
              })}

            {res?.bookmakerRunners?.length > 0 &&
              res?.bookmakerRunners?.map((item, index) => {
                let position = res?.position?.find(
                  (res) => res?.selectionId == item?.selectionID
                )?.position;
                return (
                  <>
                    <td
                      style={{
                        // display: "flex",
                        justifyContent: "flex-end",
                      }}
                      className="border-0 bg-yellow text-end"
                    >
                      <p
                        className={
                          Math.sign(position) == -1
                            ? "text-danger"
                            : "text-success text-danger-new"
                        }
                      >
                        {Math.sign(position) == -1
                          ? `(${obj.currencyFormat(Math.abs(position))})`
                          : obj.currencyFormat(Math.abs(position))}
                      </p>
                    </td>
                    {/* {index == 0 && <td className="border-0 bg-yellow"></td>} */}
                  </>
                );
              })}

            <td className="border-right-0 text-center">
              <Link
                // to={
                //   title == "Fancy Bet"
                //     ? `/DownlinePnl-Fancy/${res?.fancyName}/${res?.eventId}/${res?.marketId}/${res?.selectionId}`
                //     : `/DownlinePnl/${user._id}/${user.userType}/${res?.eventId}/${res?.marketId}/${title}`
                // }

                onClick={() => {
                  const url =
                    title === "Fancy Bet"
                      ? `/DownlinePnl-Fancy/${res?.fancyName}/${res?.eventId}/${res?.marketId}/${res?.selectionId}`
                      : `/DownlinePnl/${user._id}/${user.userType}/${res?.eventId}/${res?.marketId}/${title}`;

                  const width = window.screen.availWidth;
                  const height = window.screen.availHeight;

                  const newWindow = window.open(
                    url,
                    "_blank",
                    `width=${width},height=${height},left=0,top=0`
                  );

                  if (newWindow) newWindow.focus();
                }}
                // target="_blank"
                className="view-btn"
              >
                {title == "Fancy Bet" ? "Book" : "View"}
              </Link>
            </td>
          </tr>

          {res?.marketId == id ? (
            <DropDown
              showMatch={showMatch}
              title={title}
              type={type}
              layData={upadtedOdds?.rt?.filter((rt) => !rt.ib) || []}
              oldlayData={upadtedOddsOld?.rt?.filter((rt) => !rt.ib) || []}
              data={
                title == "Book Maker" ? res?.bookmakerRunners : res?.runners
              }
              res={res}
              backData={upadtedOdds?.rt?.filter((rt) => rt.ib) || []}
              oldbackData={upadtedOddsOld?.rt?.filter((rt) => rt.ib) || []}
              gameType={startCase(res.gameType)}
              dateTime={helpers.matchDateTimeNew(
                res.eventDateTime,
                user.timeZone
              )}
            />
          ) : (
            ""
          )}
        </>
      );
    });
  };

  const BetFair = ({ data, type, type2 }) => {
    return data?.length > 0 ? (
      data?.map((res, index) => {
        let upadtedOdds =
          odds?.find((oi) => {
            return oi?.mi == res?.marketId;
          }) || {};
        let upadtedOddsOld =
          oldOdds?.find((oi) => {
            return oi?.mi == res?.marketId;
          }) || {};
        return (
          <>
            <tr key={index + 1}>
              <>
                <td className="text-start">
                  <p className="blue-text">{startCase(res.gameType)}</p>
                </td>
                <td className="text-start">
                  {helpers.matchDateTimeNew(res?.eventDateTime, user.timeZone)}{" "}
                </td>
              </>

              <td className="bg-yellow border-0 risk-match-name">
                <a>
                  {title != "Book Maker" && (
                    <>
                      {res?.marketId == id ? (
                        <Button
                          onClick={() => {
                            setShowMatch(false);
                            setSelectData("");
                            setId("");
                          }}
                          className={"angle-up"}
                        >
                          <i className="fas fa-angle-up"></i>
                        </Button>
                      ) : (
                        <Button
                          onClick={() => {
                            setShowMatch(true);
                            setId(res?.marketId);
                            setSelectData(res);
                          }}
                          className={"angle-up down-up"}
                        >
                          <i className="fas fa-angle-up"></i>
                        </Button>
                      )}
                    </>
                  )}
                  <strong style={{ marginLeft: "10px" }}>
                    <Link
                      onClick={() =>
                        window
                          .open(
                            `/risk-betfair/${res?.eventId}/${res?.marketId}`,
                            "_blank",
                            "width=1100, height=700"
                          )
                          .focus()
                      }
                    >
                      {res.eventName}
                    </Link>
                  </strong>{" "}
                  <img className="fromto" src={iconfromto} />
                  <span className="ms-3">
                    {res?.market ? res?.market : "Bookmaker"}{" "}
                  </span>
                </a>
              </td>

              {res?.runners?.length > 0 &&
                res?.runners?.map((item, index) => {
                  let position = res?.position?.find(
                    (res) =>
                      res?.selectionId ==
                      (item?.selectionID || item?.SelectionId)
                  )?.position;
                  return (
                    <>
                      <td
                        style={{ justifyContent: "flex-end" }}
                        className="border-0 bg-yellow text-end"
                      >
                        <p
                          className={
                            Math.sign(position) == -1
                              ? "text-danger"
                              : "text-success text-danger-new"
                          }
                        >
                          {Math.sign(position) == -1
                            ? `(${obj.currencyFormat(Math.abs(position))})`
                            : obj.currencyFormat(Math.abs(position))}
                        </p>
                      </td>
                    </>
                  );
                })}

              {res?.bookmakerRunners?.length > 0 &&
                res?.bookmakerRunners?.map((item, index) => {
                  let position = res?.position?.find(
                    (res) => res?.selectionId == item?.selectionID
                  )?.position;
                  return (
                    <>
                      <td
                        // style={{
                        //   display: "flex",
                        //   justifyContent: "flex-end",
                        // }}
                        className="border-0 bg-yellow text-end"
                      >
                        <p
                          className={
                            Math.sign(position) == -1
                              ? "text-danger"
                              : "text-success text-danger-new"
                          }
                        >
                          {Math.sign(position) == -1
                            ? `(${obj.currencyFormat(Math.abs(position))})`
                            : obj.currencyFormat(Math.abs(position))}
                        </p>
                      </td>

                      {/* <td
                        style={{ justifyContent: "flex-end" }}
                        className="border-0 bg-yellow text-end"
                      >
                        <p
                          className={
                            Math.sign(position) == -1
                              ? "text-success text-danger-new"
                              : "text-danger"
                          }
                        >
                          {Math.sign(position) == -1
                            ? Math.abs(position).toFixed(2)
                            : `(${Math.abs(position).toFixed(2)})`}
                        </p>
                      </td> */}
                      {/* {index == 0 && <td className="border-0 bg-yellow"></td>} */}
                    </>
                  );
                })}

              <td className="border-right-0 text-center">
                <Link
                  // to={
                  //   title == "Fancy Bet"
                  //     ? `/DownlinePnl-Fancy/${res?.fancyName}/${res?.eventId}/${res?.marketId}/${res?.selectionId}`
                  //     : `/DownlinePnl/${user._id}/${user.userType}/${res?.eventId}/${res?.marketId}/${title}`
                  // }

                  onClick={() => {
                    const url =
                      title === "Fancy Bet"
                        ? `/DownlinePnl-Fancy/${res?.fancyName}/${res?.eventId}/${res?.marketId}/${res?.selectionId}`
                        : `/DownlinePnl/${user._id}/${user.userType}/${res?.eventId}/${res?.marketId}/${title}`;

                    const width = window.screen.availWidth;
                    const height = window.screen.availHeight;

                    const newWindow = window.open(
                      url,
                      "_blank",
                      `width=${width},height=${height},left=0,top=0`
                    );

                    if (newWindow) newWindow.focus();
                  }}
                  // target="_blank"
                  className="view-btn"
                >
                  {title == "Fancy Bet" ? "Book" : "View"}
                </Link>
              </td>
            </tr>

            {res?.marketId == id ? (
              <DropDown
                showMatch={showMatch}
                title={title}
                type={type}
                type2={type2}
                layData={upadtedOdds?.rt?.filter((rt) => !rt.ib) || []}
                oldlayData={upadtedOddsOld?.rt?.filter((rt) => !rt.ib) || []}
                data={
                  title == "Book Maker" ? res?.bookmakerRunners : res?.runners
                }
                res={res}
                backData={upadtedOdds?.rt?.filter((rt) => rt.ib) || []}
                oldbackData={upadtedOddsOld?.rt?.filter((rt) => rt.ib) || []}
                gameType={startCase(res.gameType)}
                dateTime={helpers.matchDateTimeNew(
                  res.eventDateTime,
                  user.timeZone
                )}
              />
            ) : (
              ""
            )}
          </>
        );
      })
    ) : (
      <tr>
        <td colSpan={7}>No Data</td>
      </tr>
    );
  };
  return (
    <div className="risk-management-table">
      <div className="d-flex align-items-center justify-content-between mb-2">
        <h2 className="common-heading">{title}</h2>
        <div>
          <Button className="view-btn" style={{ fontWeight: "600" }}>
            Download
          </Button>{" "}
          <Button className="view-btn" style={{ fontWeight: "600" }}>
            <i
              style={{ transform: "rotateY(180deg)" }}
              className="fas fa-redo-alt"
            ></i>
          </Button>
        </div>
      </div>

      <div className="account-table match-odd-table">
        <div className="responsive">
          <Table>
            <thead>
              <tr>
                <td width="10%" rowSpan="2">
                  <strong> Sports</strong>
                </td>
                <td width="10%" rowSpan="2">
                  <strong> Market Date</strong>
                </td>
                <td rowSpan="2">
                  <strong>Event/Market Name</strong>
                </td>
                <td
                  width="21%"
                  className="text-center border-l bg-light-yellow"
                  colSpan="3"
                >
                  <strong>Player P/L</strong>
                </td>
                <td width="6%" rowSpan="2" className="text-center">
                  <strong> Downline P/L</strong>
                </td>
              </tr>
              <tr>
                <td width="7%" className="bg-light-yellow left-border text-end">
                  <strong>{"1"}</strong>
                </td>

                <td
                  width="7%"
                  className="bg-light-yellow border-0 text-end border-b-n"
                >
                  <strong>{"X"}</strong>
                </td>
                <td
                  width="7%"
                  className="bg-light-yellow right-border text-end"
                >
                  <strong>{"2"}</strong>
                </td>
              </tr>
            </thead>

            {second?.grouped?.length > 0 || second?.others?.length > 0 ? (
              <>
                {second?.grouped?.map((res, index) => {
                  return (
                    <tbody className="match-tbody">
                      <BetFairMulti
                        type={"multi"}
                        data={res}
                        index={index}
                        indexNew={index}
                      />
                    </tbody>
                  );
                })}
                {second?.others?.length > 0 && (
                  <tbody className="match-tbody">
                    <BetFair
                      type={"multi"}
                      data={second?.others}
                      type2={"other"}
                    />
                  </tbody>
                )}
              </>
            ) : (
              <tbody>
                <tr>
                  <td colSpan={7}>No Data</td>
                </tr>
              </tbody>
            )}
          </Table>
        </div>
      </div>

      <div className="account-table match-odd-table ">
        <div className="responsive">
          <Table>
            <thead>
              <tr>
                <td width="10%" rowSpan="2">
                  <strong> Sports</strong>
                </td>
                <td width="10%" rowSpan="2">
                  <strong> Market Date</strong>
                </td>
                <td rowSpan="2">
                  <strong>Event/Market Name</strong>
                </td>
                <td
                  width="21%"
                  className="text-center border-l bg-light-yellow"
                  colSpan="2"
                >
                  <strong>Player P/L</strong>
                </td>
                <td width="6%" rowSpan="2" className="text-center">
                  <strong> Downline P/L</strong>
                </td>
              </tr>
              <tr>
                <td
                  width="7%"
                  className=" bg-light-yellow text-end left-border"
                >
                  <strong>{"1"}</strong>
                </td>

                <td
                  width="7%"
                  className="bg-light-yellow right-border text-end"
                >
                  <strong>{"2"}</strong>
                </td>
              </tr>
            </thead>
            {first?.grouped?.length > 0 || first?.others?.length > 0 ? (
              <>
                {first?.grouped?.map((res, index) => {
                  return (
                    <tbody className="match-tbody">
                      <BetFairMulti data={res} index={index} indexNew={index} />
                    </tbody>
                  );
                })}
                {first?.others?.length > 0 && (
                  <tbody className="match-tbody">
                    <BetFair
                      type={"normal"}
                      type2={"other"}
                      data={first?.others}
                    />
                  </tbody>
                )}
              </>
            ) : (
              <tbody>
                <tr>
                  <td colSpan={7}>No Data</td>
                </tr>
              </tbody>
            )}
          </Table>
        </div>
      </div>
    </div>
  );
};

export default BetTypeListing;
